<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.attendance_review'),
                        href: meta.links.attendance_review_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.attendance_review_show,
                    },
                    {
                        name: $t('messages.attendance_missing'),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState picture v-if="missing.length === 0" />
        <template v-else>
            <div v-for="day in missing" :key="day.url" class="block mt-3">
                <AppButton :href="day.url" desired-action>
                    {{ day.text }}
                </AppButton>
            </div>
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    components: {
        PanelPage,
        AppButton,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'missing', 'group'],
};
</script>
